import { Component, ComponentFactoryResolver, ComponentRef, HostListener, OnInit, Renderer2, ViewContainerRef, ViewChild, ElementRef, AfterViewChecked, AfterViewInit, OnDestroy } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { Event } from 'src/app/utils/interfaces/old/agenda-interface';
import * as moment from 'moment';
import { CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { ModalService } from 'src/app/services/modal/modal.service';
import { EventBoxFragment } from './event-box/event-box.fragment';
import { Router } from '@angular/router';
import { EventStatus } from 'src/app/utils/interfaces/new/event-status.interface';
import { EventRecurrenceComponent } from './event-recurrence/event-recurrence.component';
import { EventRecurrence, UniteDeTempsEnum } from 'src/app/utils/interfaces/new/event-recurrence.interface';
import { EventResource } from 'src/app/utils/interfaces/new/event-resource.interface';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { NextSlotComponent } from './next-slot/next-slot.component';
import { EventConflictComponent } from './event-conflict/event-conflict.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { AgendaPeriode } from 'src/app/utils/interfaces/new/AgendaPeriode';
import { LoginService } from 'src/app/services/login/login.service';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { LoadingModalFragment } from 'src/app/fragments/modal/loading/loading-modal.fragment';
import { QuillObjectDisplay, QuillObjectTypeEnum } from 'src/app/utils/interfaces/new/quill-object-display.interface';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { DisplayDocumentComponent } from 'src/app/fragments/display-document/display-document.component';
import { PerimetersService } from 'src/app/services/perimeters/perimeters.service';
import { Perimeter } from 'src/app/utils/interfaces/new/perimeter.interface';
import { PatientService } from 'src/app/services/patient/patient.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { SafeHtmlUtils } from 'src/app/utils/safe-html.util'; 
// import { DelegationService } from 'src/app/services/delegation/delegation.service';
// import { Delegation } from 'src/app/utils/interfaces/new/delegation.interface';

const CUSTOM_EVENT_ID_PREFIX = 'custom_event_';
const CUSTOM_EVENT_DROPOUT_ID_PREFIX = 'custom_event_dropout';
const BOX_EVENT_ID_PREFIX = 'box_event_';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy {
  @ViewChild('ctxMenu') ctxMenuRef: ElementRef<HTMLDivElement>;

  public calendarViewEnum = CalendarView;

  public accountName = 'Docteur Renaud';

  public smallCalendarViewDate = new Date();
  private smallCalendarElem: HTMLElement | undefined = undefined;
  private monthViewCalendarElem: HTMLElement | undefined = undefined;
  public viewDate = new Date();
  public events: Array<CalendarEvent> = [];
  public hypermedEvents: Array<Event> = [];
  public excludeDays = [0];
  public lastEventsClicked: Array<CalendarEvent> = [];
  private listStatusElem: HTMLDivElement | null = null;
  private previousElemStatusListOpened: HTMLElement | null = null;

  public formGroup: FormGroup;
  private unityChangeSub: Subscription;
  private resourceChangeSub: Subscription;

  private statusList: Array<EventStatus> = [];

  public unplannedEvents: Array<CalendarEvent> = [];
  public showedUnplannedEvents = true;
  public showedLeftPart = true;
  public calendarUnity: string = CalendarView.Week;

  private resources: Array<EventResource> = [];
  public resourcesLabel: Array<string> = [];
  public currentResource: EventResource | undefined = undefined;

  public unitySelectValues: Array<string> = [];

  public agendaStartHour = '8';
  public agendaStartMinute = '0';
  public agendaEndHour = '19';
  public agendaEndMinute = '0';
  public hourHeight = 30;
  private refreshRate = 0;
  private refreshInstance: any;
  private showHollidays = false;
  private isPrinting = false;
  private intervalTimeMarker: any;

  public dayHeaderClickedDate: { date: Date, elem: HTMLElement };

  private periodes: Array<AgendaPeriode> = [];

  private calElem: Element;

  private currentProfil: Profil;
  public perimetersList: Perimeter[];
  // private delegationProfil: Delegation[];

  private _initLoading: ComponentRef<LoadingModalFragment>;
  patientId: string;

  //gestion clic droit
  public showContextMenu = false;
  public menuPosition = { x: 0, y: 0 };
  public selectedEvent: CalendarEvent | null = null;
  private eventBoxRefs = new Map<string, ComponentRef<EventBoxFragment>>();
  private calScrollBound = false;
  public showStatusSubmenu = false;
  private closeStatusSubmenuTimer: any;
  private isAlreadyClick = false;
  private readonly STATUS_ICON_CLASS_BY_KEY: Record<string, string> = {
    'annule': 'st-cancelled',
    'deplace': 'st-moved',
    'vu par le medecin': 'st-seen',
    'en salle d attente': 'st-waiting',
    'en retard': 'st-late',
    'non honore': 'st-no-show',
  };

  constructor(
    private agendaSrv: AgendaService,
    private modalSrv: ModalService,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
    private resolver: ComponentFactoryResolver,
    private router: Router,
    private _send: HeaderCommunicationService,
    private formBuilder: FormBuilder,
    private resourceSrv: RessourceService,
    private loginService: LoginService,
    private _displayDocumentSrv: DisplayDocumentService,
    private _perimeterSrv: PerimetersService,
    private patientSrv: PatientService,
    private snack: SnackbarService,
    // private _delegationSrv: DelegationService,
  ) {
    moment.locale('fr');

    const head: Header = {
      backPage: "home",
      isBack: true,
      title: "Agenda",
    };
    this._send.announceHeader(head);
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event): void {
    this.setAgendaHeight();
  }
  public openContextMenu(e: MouseEvent, calendarEvent: CalendarEvent) {
      // 1) fermer la status list si ouverte
    if (this.previousElemStatusListOpened) {
      // remet le z-index à 1, retire la flèche "open", etc.
      try {
        this.previousElemStatusListOpened.parentElement.parentElement.style.zIndex = '1';
        // const arrow = this.previousElemStatusListOpened.querySelector('.dropOut .arrow');
        // if (arrow) this.renderer.removeClass(arrow, 'open');

        // retire la liste si présente
        const statusList = this.previousElemStatusListOpened.querySelector('.status-list-wrapper');
        if (statusList) this.previousElemStatusListOpened.removeChild(statusList);

        this.previousElemStatusListOpened = null;
      } catch {}
    }

    // 2) fermer la box hover si présente (au cas où)
    const right = document.getElementsByClassName('right-part')[0];
    const box = right?.querySelector(`div#${BOX_EVENT_ID_PREFIX}${calendarEvent.id}.event-box`);
    if (box && right) {
      try { right.removeChild(box); } catch {}
    }

    const id = String(calendarEvent.id);
    const ref = this.eventBoxRefs.get(id);
    if (ref) {
      ref.destroy();
      this.eventBoxRefs.delete(id);
    }

    e.preventDefault();
    e.stopPropagation();

    this.selectedEvent = calendarEvent;
    this.showContextMenu = true;

    // position brute
    this.menuPosition = { x: e.clientX, y: e.clientY };

    // clamp après que le menu soit dans le DOM
    setTimeout(() => this.clampContextMenuToViewport(), 0);
  }

  private clampContextMenuToViewport() {
    const el = this.ctxMenuRef?.nativeElement;
    if (!el) return;

    const rect = el.getBoundingClientRect();

    let x = this.menuPosition.x;
    let y = this.menuPosition.y;

    const pad = 8;

    // si dépasse à droite -> on recule
    if (x + rect.width > window.innerWidth - pad) {
      x = window.innerWidth - rect.width - pad;
    }
    // si dépasse en bas -> on remonte
    if (y + rect.height > window.innerHeight - pad) {
      y = window.innerHeight - rect.height - pad;
    }

    // éviter valeurs négatives
    x = Math.max(pad, x);
    y = Math.max(pad, y);

    this.menuPosition = { x, y };
  }

  @HostListener('document:click')
  public closeContextMenu() {
    this.showContextMenu = false;
    this.selectedEvent = null;
    this.showStatusSubmenu = false;
  }

  onDocumentClick() {
    if (this.showContextMenu) this.closeContextMenu();
  }

  // ESC
  @HostListener('document:keydown.escape')
  onEsc() {
    if (this.showContextMenu) this.closeContextMenu();
  }

  private setSelectionFromContext() {
    if (!this.selectedEvent) return;
    this.lastEventsClicked = [this.selectedEvent];
  }

  public setAgendaHeight(): void {
    // Suppression de l'overflow sur toute la page
    const content = document.getElementsByClassName('content')[0];
    if (content) {
      this.renderer.setStyle(content, 'overflow', 'unset');
      this.renderer.setStyle(content.parentElement, 'overflow', 'unset');
    }

    // Récupération de l'élément à modifier
    const contentWrapper = document.getElementsByClassName('page-content-wrapper');

    // Récupération du header afin de calculer sa hauteur + la taille de son margin
    const agendaHeader = document.getElementsByClassName('header')[0];
    if (agendaHeader) {
      const elmHeight = parseInt(document.defaultView.getComputedStyle(agendaHeader, '').getPropertyValue('height').split('px')[0], 10);
      const elmMargin = parseInt(document.defaultView.getComputedStyle(agendaHeader, '')
        .getPropertyValue('margin-top'), 10) +
        parseInt(document.defaultView.getComputedStyle(agendaHeader, '')
          .getPropertyValue('margin-bottom'), 10);

      // + 30 équivaut à rajouter 30 de padding au bottom
      const agendaSize = window.innerHeight - (elmHeight + elmMargin + 30);

      // Ajout du max-height sur l'élément à contenir afin qu'il ai la bonne taille en toute circonstance
      if (contentWrapper) {
        this.renderer.setStyle(contentWrapper[0], 'height', agendaSize + 'px');
      }
    }

    if (this.calendarUnity === this.calendarViewEnum.Week) {
      const rightPart = document.getElementsByClassName('right-part')[0];
      if (rightPart) {
        const rightPartTop = rightPart.getElementsByClassName('top-agenda')[0];
        const rightPartCalendar = rightPart.querySelector('div.cal-time-events');//[0];

        const maxHeightCalc = rightPart.clientHeight
          - (
            rightPartTop.clientHeight + parseInt(document.defaultView.getComputedStyle(rightPartTop).marginBottom.split('px')[0], 10)
          );

        if (rightPartTop && rightPartCalendar) {
          this.renderer.setStyle(rightPartCalendar, 'max-height', `${maxHeightCalc}px`);
        }
      }
    }
  }

  async ngOnInit(): Promise<void> {
    if (!this._initLoading) {
      this._initLoading = this.modalSrv.openLoading(this.viewContainerRef);

      this._initLoading.onDestroy(() => {
        this._initLoading = undefined;
      });
    }

    try {
      this.currentProfil = this.loginService.getCurrentProfil();

      //on va chercher perimeter pour filtrer le ressources profil affichable.
      this.perimetersList = await this._perimeterSrv.findPerimeters('delegataire');
      this.perimetersList = this.perimetersList.filter(p =>
        (p.scope || '').toLowerCase() === 'agenda' && p.value === true
      );

      // this.delegationProfil = await this._delegationSrv.findReceivedDelegations();

      const navParamViewDate = this.getNavigationParams('agenda_nav_viewdate');
      if (navParamViewDate) {
        this.viewDate = moment(navParamViewDate).toDate();
      }

      const navParamCurrentResource = this.getNavigationParams('agenda_nav_current_resource');
      if (navParamCurrentResource) {
        this.currentResource = JSON.parse(navParamCurrentResource);
      }

      // on recupere la liste des ressources (liste des agendas accessibles)
      this.resources = await this.getResources();
      // 1. Extraire les `id` des objets dans `idExclu`
      const idRessourceOK = this.perimetersList.map(item => item.idDelegant);
      // 2. Filtrer `this.resources` pour supprimer les éléments dont l'id est dans `idsInutilesIds`
      this.resources = this.resources.filter(resource =>
        resource.superType === 'ressource' ||
        (idRessourceOK.includes(resource.id) && resource.superType === 'profil') ||
        resource.id === this.currentProfil.id
      );
      for (const r of this.resources) {
        this.resourcesLabel.push(r.nom);
      }

      this.statusList = await this.getStatusList();

      await this.initData();
    } catch (e) {
      const modal = this.modalSrv.openAlert(
        this.viewContainerRef,
        'Erreur',
        'Une erreur est survenue lors du chargement des données de cette page'
      );
    } finally {
      if (this._initLoading) {
        this._initLoading.destroy();
      }
    }
  }

  ngAfterViewChecked(): void {
    if (this.calScrollBound) return;

    const calElem = document.querySelector('div.cal-time-events') as HTMLElement | null;
    if (!calElem) return;

    this.calScrollBound = true;

    calElem.onscroll = () => {
      const right = document.getElementsByClassName('right-part')[0] as HTMLElement | undefined;
      if (!right) return;

      const boxes = right.querySelectorAll('div.event-box');
      boxes.forEach((b) => {
        try { right.removeChild(b); } catch (e) {}
      });
    };

    this.setAgendaHeight();
  }

  private async initData(): Promise<void> {
    let currentProfilId;
    if (!this.currentResource) {
      const currentProfilStr = localStorage.getItem('currentProfil');
      if (currentProfilStr && currentProfilStr !== '') {
        const currentProfil = JSON.parse(currentProfilStr);
        currentProfilId = currentProfil && currentProfil.id ? currentProfil.id : this.resources[0].id;
      } else {
        currentProfilId = this.resources[0].id;
      }

      this.currentResource = this.resources.find(r => r.id === currentProfilId);
    }

    await this._getResourceSettings(this.currentResource.id, this.currentResource.superType);

    (async () => {
      try {
        const events = await this.getUnplannedEvents();  // Appel asynchrone en arrière-plan
        this.unplannedEvents = events;
      } catch (error) {
        console.error('Erreur lors de la récupération des événements non planifiés', error);
      }
    })();

    await this.handleEvents();

    // this.unitySelectValues = ['Jour', 'Semaine', 'Mois'];
    this.unitySelectValues = ['Jour', 'Semaine'];

    this.formGroup = this.formBuilder.group({
      unity: ['Semaine'],
      resource: [this.currentResource ? this.currentResource.nom : this.resourcesLabel[0]]
    });

    this.unityChangeSub = this.formGroup.get('unity').valueChanges.subscribe((unity) => {
      switch (unity) {
        case 'Jour':
          this.changeUnity(CalendarView.Day);
          break;
        case 'Semaine':
          this.changeUnity(CalendarView.Week);
          break;
        case 'Mois':
          this.changeUnity(CalendarView.Month);
          break;
      }
    });

    this.resourceChangeSub = this.formGroup.get('resource').valueChanges.subscribe((resource) => {
      this.changeResource(resource);
    });

    if (this.refreshRate > 0) {
      if (this.refreshInstance) {
        clearInterval(this.refreshInstance);
      }

      this.refreshInstance = setInterval(async () => {
        await this.initData();
      }, this.refreshRate);
    }
  }

  ngAfterViewInit() {
    this._initTimeMarker();
  }

  ngOnDestroy() {
    if (this.unityChangeSub) {
      this.unityChangeSub.unsubscribe();
    }

    if (this.resourceChangeSub) {
      this.resourceChangeSub.unsubscribe();
    }

    if (this.refreshInstance) {
      clearInterval(this.refreshInstance);
    }

    if (this.intervalTimeMarker) {
      clearInterval(this.intervalTimeMarker);
    }

    // On modifie l'overflow pour ne pas impacter les autres pages
    const content = document.getElementsByClassName('content')[0];
    if (content) {
      this.renderer.setStyle(content, 'overflow', 'auto');
      this.renderer.setStyle(content.parentElement, 'overflow', 'auto');
    }
    this.eventBoxRefs.forEach(r => r.destroy());
    this.eventBoxRefs.clear();
    this.calScrollBound = false;
  }

  public GetTitleCalendar(){
    const start = moment(this.viewDate).startOf('week').format('D MMM yyyy');;
    const end = moment(this.viewDate).endOf('week').format('D MMM yyyy');
    // date:"EEEE d MMMM yyyy"
    const NumOfWeek = this._getWeekNumber(moment(this.viewDate).startOf('week').toDate())

    return `Semaine (${NumOfWeek}) - ${start} au ${end}`;
  }
  private _getWeekNumber(date: Date): number {
    // Copier la date pour éviter de modifier l'objet d'origine
    const target = new Date(date);
    // Définir le lundi comme premier jour de la semaine
    target.setHours(0, 0, 0, 0);
    // Définir au jeudi dans la semaine courante pour respecter l'ISO 8601
    target.setDate(target.getDate() + 3 - (target.getDay() + 6) % 7);
    // Calculer le premier jour de l'année
    const firstThursday = new Date(target.getFullYear(), 0, 4);
    // Nombre de jours depuis le premier jeudi de l'année
    const diff = target.getTime() - firstThursday.getTime();
    // Calculer le numéro de la semaine
    return 1 + Math.round(diff / (7 * 24 * 60 * 60 * 1000));
  }

  private async handleEvents() {
    if (!this._initLoading) {
      this._initLoading = this.modalSrv.openLoading(this.viewContainerRef);

      this._initLoading.onDestroy(() => {
        this._initLoading = undefined;
      });
    }

    try {
      await this.getEvents();

      await this.handleEventsInDom();

      const periodeStart = moment(this.viewDate).startOf(this.calendarUnity as any).toDate();
      const periodeEnd = moment(this.viewDate).endOf(this.calendarUnity as any).toDate();


      this.periodes = await this.agendaSrv.getAgendaPeriodes(this.currentResource.id, this.currentResource.superType, periodeStart, periodeEnd);

      if (this.showHollidays) {
        // const hollidays = await this.agendaSrv.getJoursFeries(moment(this.viewDate).format('YYYY'));
        // for (const h of hollidays) {
        //   if (moment(h.date).isBetween(periodeStart, periodeEnd)) {
        //     this.periodes.push({
        //       couleurFond: '#f7d1a2',
        //       couleurTexte: '#ffa500',
        //       heureDebut: '00:00',
        //       heureFin: '00:00',
        //       id: 'ID_HOLLIDAY_' + h.nom.replace(/ /g, '_'),
        //       titre: h.nom,
        //       periodeDateDebut: h.date,
        //       periodeDateFin: h.date,
        //       autoriserPriseRendezVous: false
        //     });
        //   }
        // }
      }

      this.handlePeriodesDisplay(this.periodes);
    } catch (e) {
      this.modalSrv.openAlert(this.viewContainerRef, 'Erreur', 'Une erreur est survenue lors du chargement des informations de cette page');
      console.error(e);
    } finally {
      if (this._initLoading) {
        this._initLoading.destroy();
      }
    }
  }

  public extendLeftPart(): void {
    this.showedLeftPart = !this.showedLeftPart;
  }

  public extendUnplannedEvents(): void {
    this.showedUnplannedEvents = !this.showedUnplannedEvents;
  }

  public async navigateToToday(): Promise<void> {
    const previousViewDate = new Date(this.viewDate);
    this.viewDate = new Date();
    this.smallCalendarViewDate = new Date();
    this.resetSmallCalendarSelection();
    if (!moment(previousViewDate).isSame(new Date(), 'week')) {
      await this.handleEvents();
    }
  }

  private resetSmallCalendarSelection(): void {
    if (this.smallCalendarElem) {
      this.renderer.removeClass(this.smallCalendarElem, 'clicked-day');
      this.smallCalendarElem = null;
    }
  }

  public async navigateToPrevious(): Promise<void> {
    let tmpDate = moment(this.viewDate).subtract(1, (this.calendarUnity as 'day' | 'week' | 'month'));
    if (this.calendarUnity === this.calendarViewEnum.Day && tmpDate.day() === 0) {
      tmpDate.subtract(1, (this.calendarUnity as 'day' | 'week' | 'month'));
    }

    this.viewDate = tmpDate.toDate();
    await this.handleEvents();

    if (this.calendarUnity === this.calendarViewEnum.Day) {
      this.handleSmallCalendarDisplay();
    }
  }

  public async navigateToNext(): Promise<void> {
    let tmpDate = moment(this.viewDate).add(1, (this.calendarUnity as 'day' | 'week' | 'month'));
    if (this.calendarUnity === this.calendarViewEnum.Day && tmpDate.day() === 0) {
      tmpDate.add(1, (this.calendarUnity as 'day' | 'week' | 'month')).toDate();
    }

    this.viewDate = tmpDate.toDate();
    await this.handleEvents();

    if (this.calendarUnity === this.calendarViewEnum.Day) {
      this.handleSmallCalendarDisplay();
    }
  }

  public smallCalendarNavigateToPrevious() {
    this.smallCalendarViewDate = moment(this.smallCalendarViewDate).subtract(1, 'month').toDate();
  }

  public smallCalendarNavigateToNext() {
    this.smallCalendarViewDate = moment(this.smallCalendarViewDate).add(1, 'month').toDate();
  }

  private handleSmallCalendarDisplay() {
    this.smallCalendarViewDate = this.viewDate;
    const elems = document.querySelectorAll('.small-agenda-wrapper mwl-calendar-month-view .cal-days .ng-star-inserted .cal-cell-row mwl-calendar-month-cell .cal-cell-top');
    moment.locale('fr');
    const viewDate = moment(this.smallCalendarViewDate).format('dddd MMMM DD');
    elems.forEach((elem) => {
      if ((elem as any).ariaLabel === viewDate) {
        if (this.smallCalendarElem) {
          this.renderer.removeClass(this.smallCalendarElem, 'clicked-day');
        }

        this.smallCalendarElem = this.getMonthCellParent(elem as HTMLElement);
        this.renderer.addClass(this.smallCalendarElem, 'clicked-day');
      }
    });
  }

  private async changeUnity(unity: string): Promise<void> {
    this.calendarUnity = unity;
    await this.handleEvents();

    if (this.calendarUnity === this.calendarViewEnum.Month) {
      const nodeList = document.querySelectorAll('.agenda-wrapper mwl-calendar-month-cell.cal-today');
      if (nodeList.length > 0) {
        this.monthViewCalendarElem = nodeList[0] as HTMLElement;
        this.renderer.addClass(this.monthViewCalendarElem, 'clicked-day');
      }
    } else if (this.calendarUnity === this.calendarViewEnum.Day) {
      const calendarWrapperElem = document.querySelector('.agenda-wrapper mwl-calendar-day-view').parentElement;
      calendarWrapperElem.style.overflow = 'hidden auto';
    } else if (this.calendarUnity === this.calendarViewEnum.Week) {
      const calendarWrapperElem = document.querySelector('.agenda-wrapper mwl-calendar-week-view').parentElement;
      calendarWrapperElem.style.overflow = 'initial';
      this._initTimeMarker();
    }
  }

  public async getNextSlot(): Promise<void> {
    if (this.currentResource) {
      const modal = this.modalSrv.openModal(this.viewContainerRef, NextSlotComponent);
      modal.instance.lengths = await this.agendaSrv.getEventHourSplits();
      modal.instance.eventTypes = await this.agendaSrv.getEventTypes();
      modal.instance.resource = this.currentResource;
      modal.instance.resources = this.resources;
      const sub = modal.instance.closeEmitter.subscribe(async (slot: any | undefined) => {
        if (slot) {
          this.setNavigationParams();
          await this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/create`], {
            queryParams: {
              'slotStart': slot.slotStart,
              'slotEnd': slot.slotEnd,
              'forceSlot': slot.eventTypeId ? false : true,
              'resourceId': slot.resourceId,
              'resourceType': slot.resourceType,
              'resourceName': slot.resourceName,
              'eventTypeId': slot.eventTypeId
            }
          }));
        }
        modal.destroy();
        sub.unsubscribe();
      });
    }
  }

  public async createNewEvent(): Promise<void> {
    this.setNavigationParams();

    await this.router.navigateByUrl(this.router.createUrlTree(['/user/agenda/create'], {
      queryParams: {
        'resourceId': this.currentResource.id,
        'resourceType': this.currentResource.superType,
        'resourceName': this.currentResource.nom,
        'dayStartHour': `${this.agendaStartHour}:${this.agendaStartMinute}`,
        'dayEndHour': `${this.agendaEndHour}:${this.agendaEndMinute}`
      }
    }));
  }

  public openSettings(): void {
    this.setNavigationParams();
    this.router.navigateByUrl(`/user/agenda/parameters/${this.currentResource.id}/${this.currentResource.superType}`);
  }

  public openSearch(): void {
    this.setNavigationParams();
    this.router.navigateByUrl('/user/agenda/search');
  }

  public async doModifyEvent(event?: CalendarEvent | null): Promise<void> {
    this.setNavigationParams();

    const target = this.getTargetEvent(event);
    if (!target) return;

    await this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/update/${target.id}`], {
      queryParams: {
        resourceId: this.currentResource.id,
        resourceType: this.currentResource.superType,
        resourceName: this.currentResource.nom
      }
    }));
  }

  public async doDeleteEvent(event?: CalendarEvent | null): Promise<void> {
    const targets = this.getTargetEvents(event);
    if (!targets.length) return;

    const modalMsg = targets.length > 1
      ? 'Voulez-vous supprimer ces rendez-vous ?'
      : 'Voulez-vous supprimer ce rendez-vous ?';

    const modal = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Supprimer', modalMsg);

    const sub = modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        for (const ev of targets) {
          await this.__doDeleteEvent(ev.id as string);
        }
      }
      sub.unsubscribe();
    });
  }

  public async doDuplicateEvent(event?: CalendarEvent | null): Promise<void> {
    // if (this.lastEventsClicked.length === 1 || event) {
    //   this.setNavigationParams();
    //   await this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/duplicate/${this.lastEventsClicked[0].id}`], { queryParams: { 'doDuplicate': true } }));
    // }

    this.setNavigationParams();
    const target = this.getTargetEvent(event);
    if (!target) return;
    await this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/duplicate/${target.id}`], { queryParams: { 'doDuplicate': true } }));
  }

  public doReportEvent(event?: CalendarEvent | null): void {
    // if (this.lastEventsClicked.length === 1 || event) {
    //   this.setNavigationParams();
    //   this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/update/${this.lastEventsClicked[0].id}`], { queryParams: { highlight: true } }));
    // }
    this.setNavigationParams();
    const target = this.getTargetEvent(event);
    if (!target) return;
    this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/update/${target.id}`], { queryParams: { highlight: true } }));
  }

  public doRepeatEvent(event?: CalendarEvent): void {
    if (this.lastEventsClicked.length === 1) {
      const event = this.getEventByIdFromLocalList(this.lastEventsClicked[0].id as string);
      const modal = this.modalSrv.openModal(this.viewContainerRef, EventRecurrenceComponent);
      modal.instance.recurrence = event.recurrence ? event.recurrence : {
        delais: 1,
        dateDebutInitiale: new Date(),
        dateFinInitiale: new Date(),
        id: '',
        uniteDeTemps: 'week' as UniteDeTempsEnum,
        finRecurrence: { type: 'ocurrenceNumber', ocurrenceNumber: 2 },
        weekProperties: { dayOfWeek: [] }
      } as EventRecurrence;
      modal.instance.eventDate = event.dateDebut;
      const sub = modal.instance.closeEmitter.subscribe(async (rtd: EventRecurrence | null) => {
        modal.destroy();
        if (rtd) {
          event.recurrence = rtd;
          await this.updateEvent(event);
        }
        modal.destroy();
        sub.unsubscribe();
      });
    }
  }

  public async changeResource(resourceLabel: string): Promise<void> {
    this.currentResource = this.resources.find(r => r.nom === resourceLabel);
    await this.initData();
  }

  /**
   * Méthode appelée par la librairie angular-calendar lors d'un click sur un jour du petit calendrier
   */
  public async monthDayClicked(event: any): Promise<void> {
    this.viewDate = event.day.date;
    this.smallCalendarViewDate = event.day.date;

    this.resetSmallCalendarSelection();

    this.smallCalendarElem = this.getMonthCellParent((event.sourceEvent.srcElement as HTMLElement));
    this.renderer.addClass(this.smallCalendarElem, 'clicked-day');
    await this.handleEvents();
  }

  private getMonthCellParent(elem: HTMLElement): HTMLElement {
    if (elem.tagName !== 'MWL-CALENDAR-MONTH-CELL') {
      return this.getMonthCellParent((elem.parentNode as HTMLElement));
    } else {
      return elem;
    }
  }

  /**
   * Méthode appelée par la librairie angular-calendar lorsqu'un drag n drop a été effectué sur un event
   */
  public async eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent) {
    if (!this._isAllowInPeriode(newStart, newEnd)) {
      const modal = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Période interdite', 'Vous essayez d\'enregistrer ce rendez-vous pendant une période pour laquelle ce n\'est pas autorisé. Voulez-vous forcer l\'enregistrement ?');
      const sub = modal.instance.closeEmitter.subscribe(async (res) => {
        if (res) {
          await this._eventTimesChanged({ event, newStart, newEnd } as CalendarEventTimesChangedEvent, true);
        }
        sub.unsubscribe();
      });
    } else {
      await this._eventTimesChanged({ event, newStart, newEnd } as CalendarEventTimesChangedEvent);
    }
  }

  /**
   * Méthode appelé lors d'un drag and drop au sein de la liste des event non planifiés
   */
  public async unplannedDrop(event: any): Promise<void> {
    // Si l'event est déjà présent dans la liste des events non planifiés, on return tout de suite pour ne rien modifier
    const unplannedEventIndex = this.unplannedEvents.indexOf(event);
    if (unplannedEventIndex > -1) {
      return;
    }

    if (!this._initLoading) {
      this._initLoading = this.modalSrv.openLoading(this.viewContainerRef);

      this._initLoading.onDestroy(() => {
        this._initLoading = undefined;
      });
    }

    const rollBackEvent = { ...event };

    // On retire l'event de la liste des agenda events
    const eventIndex = this.events.indexOf(event);
    this.events.splice(eventIndex, 1);
    this.events = [...this.events];

    // On ajoute l'event à la liste des event non planifiés
    this.unplannedEvents.push(event);

    try {
      // On récupère et modifie l'event
      const hypermedEvent = this.hypermedEvents.find((e) => e.id === event.id);
      hypermedEvent.planifie = false;

      // On enregistre les modifications
      await this.agendaSrv.updateEvent(hypermedEvent, true);
    } catch (e) {
      // En cas d'erreur lors de l'enregistrement, on rollback les données locales
      const eventIndex = this.events.indexOf(event);
      if (eventIndex < 0) {
        this.events.push(event);
        this.events = [...this.events];
      }

      const unplannedEventIndex = this.unplannedEvents.indexOf(event);
      if (unplannedEventIndex > -1) {
        this.unplannedEvents.splice(eventIndex, 1);
        this.unplannedEvents = [...this.unplannedEvents];
      }

      let hypermedEvent = this.hypermedEvents.find((e) => e.id === event.id);
      hypermedEvent = rollBackEvent;
    } finally {
      if (this._initLoading) {
        this._initLoading.destroy();
      }
    }
  }

  /**
   * Méthode appelée par la librairie angular-calendar lors d'un click sur un event
   */
  public eventClicked(event: any) {
    const se: MouseEvent | undefined = event?.sourceEvent;
    // On ignore tout sauf clic gauche
    // - se.button: 0 gauche, 1 milieu, 2 droit
    if (se && se.button !== 0) return;
    // (Optionnel) si ton menu contextuel est ouvert, on ignore les clics
    if (this.showContextMenu) return;

    const eventIndex = this.lastEventsClicked.findIndex((e) => e.id === event.event.id);
    if (eventIndex < 0) {
      if (event.event.meta.infosAccessible) {
        event.event.actions = [{
          label: '',
          onClick() {
          }
        }];
        this.lastEventsClicked.push(event.event);
      }
    } else {
      this.lastEventsClicked[eventIndex].actions = null;
      this.lastEventsClicked.splice(eventIndex, 1);
    }

    if (this.dayHeaderClickedDate) {
      this.dayHeaderClickedDate.elem.style.backgroundColor = this.dayHeaderClickedDate.elem.classList.contains('cal-today') ? '#e8fde7' : 'unset';
      this.dayHeaderClickedDate.elem.style.color = 'unset';
      this.dayHeaderClickedDate = undefined;
    }
  }

  /**
   * Méthode appelée par la librairie angular-calendar lorsqu'un segment d'heure a été clické
   */
  public async hourSegmentClicked(event: any) {
    const slotStart = event.date;
    const slotEnd = moment(event.date).add(15, 'minute').toDate();
    if (!this._isAllowInPeriode(slotStart, slotEnd)) {
      const modal = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Période interdite', 'Vous essayez de créer un rendez-vous pendant une période pour laquelle ce n\'est pas autorisé. Voulez-vous forcer la création de rendez-vous ?');
      const sub = modal.instance.closeEmitter.subscribe(async (res) => {
        if (res) {
          await this._hourSegmentClicked(slotStart, slotEnd, true);
        }
        sub.unsubscribe();
      });
    } else {
      await this._hourSegmentClicked(slotStart, slotEnd);
    }
  }

  public async dayHeaderClicked(event: any) {
    const getHeader = async (e: HTMLElement) => {
      return new Promise<HTMLElement>(async (resolve) => {
        if (!e.classList || !e.classList.contains('cal-header')) {
          resolve(await getHeader(e.parentElement));
        } else {
          resolve(e);
        }
      });
    }

    const resetStyle = (e: HTMLElement) => {
      e.style.backgroundColor = e.classList.contains('cal-today') ? '#e8fde7' : 'unset';
      e.style.color = 'unset';
      return e;
    }

    const setStyle = (e: HTMLElement) => {
      e.style.backgroundColor = 'var(--primary)';
      e.style.color = 'var(--white)';
      return e;
    }

    let elem = await getHeader(event.sourceEvent.target as HTMLElement);

    if (this.dayHeaderClickedDate) {
      this.dayHeaderClickedDate.elem = resetStyle(this.dayHeaderClickedDate.elem);
    }

    if (!this.dayHeaderClickedDate || this.dayHeaderClickedDate.date !== event.day.date) {
      elem = setStyle(elem);
      this.dayHeaderClickedDate = {
        date: event.day.date,
        elem
      };
    } else {
      this.dayHeaderClickedDate.elem = resetStyle(this.dayHeaderClickedDate.elem);
      this.dayHeaderClickedDate = undefined;
    }

    for (const e of this.lastEventsClicked) {
      e.actions = undefined;
    }
    this.lastEventsClicked = [];
  }

  public async copyEvents(type: 'day' | 'week') {
    this.setNavigationParams();
    await this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/repeat-model`], {
      queryParams: {
        type: type,
        date: this.dayHeaderClickedDate.date,
        resourceId: this.currentResource.id,
        resourceType: this.currentResource.superType
      }
    }));
  }

  private async _hourSegmentClicked(slotStart: Date, slotEnd: Date, doForce = false) {
    this.setNavigationParams();
    await this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/create`], {
      queryParams: {
        slotStart,
        slotEnd,
        doForce,
        resourceId: this.currentResource.id,
        resourceType: this.currentResource.superType,
        resourceName: this.currentResource.nom,
        dayStartHour: `${this.agendaStartHour}:${this.agendaStartMinute}`,
        dayEndHour: `${this.agendaEndHour}:${this.agendaEndMinute}`
      }
    }));
  }

  private async getEvents(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let unity = this.calendarUnity
        let start = this.viewDate;
        let end = this.viewDate;
        if(this.calendarUnity == 'day'){
          start = moment(this.viewDate).hour(Number(this.agendaStartHour)).minute(Number(this.agendaStartMinute)).second(0).millisecond(0).toDate();
          end = moment(this.viewDate).hour(Number(this.agendaEndHour)).minute(Number(this.agendaEndMinute)).second(0).millisecond(0).toDate();
        }else {
          start = moment(this.viewDate).startOf('week').hour(Number(this.agendaStartHour)).minute(Number(this.agendaStartMinute)).second(0).millisecond(0).toDate();
          end = moment(this.viewDate).endOf('week').hour(Number(this.agendaEndHour)).minute(Number(this.agendaEndMinute)).second(0).millisecond(0).toDate();
        }

        // const start = moment(this.viewDate).startOf('week').hour(Number(this.agendaStartHour)).minute(Number(this.agendaStartMinute)).toDate();
        // const end = moment(this.viewDate).endOf('week').hour(Number(this.agendaEndHour)).minute(Number(this.agendaEndMinute)).toDate();
        const tmpEvents = await this.agendaSrv.getEvents(start, end, this.currentResource);

        for (const e of tmpEvents) {
          if (e.patient) {
            e.patient.dateNaissance = e.patient.dateNaissance.split('-').reverse().join('-');
          }
        }

        this.hypermedEvents = [...this.hypermedEvents, ...tmpEvents];

        const eventsArr: Array<CalendarEvent> = [];

        for (const event of tmpEvents) {
          const patientLabel = event.patient
            ? `${SafeHtmlUtils.escapeHtml(event.patient.nom)} ${SafeHtmlUtils.escapeHtml(event.patient.prenom)} (${SafeHtmlUtils.escapeHtml(event.patient.dateNaissance)})`
            : '';

          const descLabel = SafeHtmlUtils.escapeHtml((event.description || '').trim());

          const title =
            patientLabel && descLabel ? `${patientLabel} - ${descLabel}` :
            patientLabel ? patientLabel :
            descLabel ? descLabel :
            'Aucune information';
          eventsArr.push({
            id: event.id,
            title: title,
            start: new Date(event.dateDebut),
            end: new Date(event.dateFin),
            draggable: event.infosAccessible && !this.isEventReadOnly(event),
            resizable: {
              afterEnd: event.infosAccessible && !this.isEventReadOnly(event),
              beforeStart: event.infosAccessible && !this.isEventReadOnly(event),
            },
            cssClass: 'custom-calendar',
            color: {
              primary: this.getEventColor(event),
              secondary: this._hexToRgba(this.getEventColor(event),0.35)//'var(--white)'
            },
            meta: event
          });
        }

        this.events = [...eventsArr];
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  private _hexToRgba(hex, opacity) {
    // Enlever le "#" s'il est présent
    hex = hex.replace('#', '');
    if (hex.length !== 6) {
      console.warn("Couleur hexadécimale invalide. Utilisation de la couleur par défaut #000000.");
      hex = "a7d54e"; // Valeur de repli par défaut : noir
  }
    // Convertir les composants hex en décimaux
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Retourner la couleur en format RGBA avec l'opacité spécifiée
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  async printRdv() {
    let start = new Date();
    let end = new Date();

    if(this.calendarUnity == "week"){
      start = moment(this.viewDate).startOf('week').hour(Number(this.agendaStartHour)).minute(Number(this.agendaStartMinute)).toDate();
      end = moment(this.viewDate).endOf('week').hour(Number(this.agendaEndHour)).minute(Number(this.agendaEndMinute)).toDate();
    }else {
      start = moment(this.viewDate).startOf('day').hour(Number(this.agendaStartHour)).minute(Number(this.agendaStartMinute)).toDate();
      end = moment(this.viewDate).endOf('day').hour(Number(this.agendaEndHour)).minute(Number(this.agendaEndMinute)).toDate();
    }
    // const start = moment().startOf('day').hour(Number(this.agendaStartHour)).minute(Number(this.agendaStartMinute)).toDate();
    // const end = moment().endOf('day').hour(Number(this.agendaEndHour)).minute(Number(this.agendaEndMinute)).toDate();
    const textToPrint = await this.agendaSrv.getEventsForPrint(start, end, this.currentResource);

    if (textToPrint) {
      const diagQuillToPrint: QuillObjectDisplay = {
        objectId: this.patientId,
        texte: textToPrint ? textToPrint : "",
        titre: "Rdv Agenda",
        typeObject: QuillObjectTypeEnum.AGENDA_JOUR,
        // date: new Date()
      }

      const displayDocumentInstance = await this._displayDocumentSrv.displayDocument(
        this.viewContainerRef,
        await this._displayDocumentSrv.quillToDisplayContentData(diagQuillToPrint)
      ) as ComponentRef<DisplayDocumentComponent>;
    }
  }

  /**
   * Cette méthode parcours les events du DOM dans le but de setter les données (contenu et couleur)du décrochement
   */
  private async handleEventsInDom(): Promise<void> {
    return new Promise<void>(async (resolve) => {

      const domEvents = document.querySelectorAll('.custom-calendar mwl-calendar-week-view-event div.cal-event');

      if (!this.canHandleEventsInDom(domEvents)) {
        setTimeout(async () => {
          await this.handleEventsInDom();
        }, 200);
      } else {
        type AgendaEventNode = Element & {
          __agendaListenersBound?: boolean;
        };

        domEvents.forEach((n) => {
          const node = n as AgendaEventNode;

          if (node.__agendaListenersBound) {
            return;
          }
          node.__agendaListenersBound = true;

          this.renderer.listen(n, 'dblclick', (event) => {
            this.handleDoubleClick(event);
          });

          this.renderer.listen(n, 'contextmenu', (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const eventId = this.getEventIdFromDOM(n);
            if (!eventId) return;
            const calendarEvent = this.events.find(ev => String(ev.id) === String(eventId));
            if (!calendarEvent) return;

            this.openContextMenu(e, calendarEvent);
          });

          //this.setEventDropOut(n);
          this.setEventBoxForEvent(n);
        });
      }

      resolve();
    });
  }

  private handleDoubleClick(event) {
    const eventId = this.getEventIdFromDOM(event.srcElement);
    if (!eventId) return;
    const cacheEvent = this.agendaSrv.eventsCache.get(eventId);
    if (cacheEvent && cacheEvent.infosAccessible) {
      this.setNavigationParams();
      this.router.navigateByUrl(this.router.createUrlTree([`/user/agenda/update/${eventId}`], {
        queryParams: {
          'resourceId': this.currentResource.id,
          'resourceType': this.currentResource.superType,
          'resourceName': this.currentResource.nom
        }
      }));
    }
  }

  private setEventBoxForEvent(elem: Element): void {
    // On récupère l'event ID auquel est rattaché le node
    const eventId = this.getEventIdFromDOM(elem);
    if (!eventId) return;
    // On récupère l'event auquel est rattaché le node grâce à son ID
    const event = this.getEventByIdFromLocalList(eventId);

    this.setEventBox(event, elem);
  }

  private setEventDropOut(elem: Element): void {
    // On récupère l'event ID auquel est rattaché le node
    const eventId = this.getEventIdFromDOM(elem);
    if (!eventId) return;
    // On récupère l'event auquel est rattaché le node grâce à son ID
    const event = this.getEventByIdFromLocalList(eventId);

    this.setEventBox(event, elem);

    // On détermine le label du décrochement de l'event
    const droptOutLabel = event && event.status && event.status.label !== '' ? event.status.label : 'Statut';

    // On récupère la couleur des border de l'event qui correspondent au type de rendez-vous
    const eventColor = this.getEventColor(event);

    // On set l'ID de l'élément rattaché à l'event
    (elem as Element).setAttribute('id', `${CUSTOM_EVENT_ID_PREFIX}${eventId}`);

    let dropOutElem = (document.querySelector(`#${CUSTOM_EVENT_DROPOUT_ID_PREFIX}${eventId}`) as HTMLDivElement);
    if (!dropOutElem && event.infosAccessible) {
      dropOutElem = document.createElement('div');
      this.renderer.addClass(dropOutElem, 'dropOut');
      this.renderer.setAttribute(dropOutElem, 'data-event-id', eventId);
      this.renderer.setAttribute(dropOutElem, 'id', `${CUSTOM_EVENT_DROPOUT_ID_PREFIX}${eventId}`);

      const labelDropOut = document.createElement('div');
      const arrowDropOut = document.createElement('div');

      this.renderer.addClass(labelDropOut, 'label');
      this.renderer.addClass(arrowDropOut, 'arrow');

      labelDropOut.innerText = droptOutLabel;

      dropOutElem.onclick = (e) => {
        const eventId = (e.currentTarget as Element).getAttribute('data-event-id');
        const calendarEvent = this.events.find((ev) => ev.id === eventId);
        this.openCloseStatusList(calendarEvent);
        e.stopPropagation();
      };

      dropOutElem.appendChild(labelDropOut);
      if (!this.isEventReadOnly(event)) {
        dropOutElem.appendChild(arrowDropOut);
      }
      dropOutElem.appendChild(document.createElement('style')).innerHTML = `.dropOut#${CUSTOM_EVENT_DROPOUT_ID_PREFIX}${eventId} { content: "${droptOutLabel}" !important; background-color: ${eventColor} !important; }`;

    }
    if (dropOutElem) {
      this.renderer.setAttribute(dropOutElem, 'title', `${droptOutLabel}`);
      elem.appendChild(dropOutElem);
    }
  }

  private setEventBox(event: Event, elem: Element): void {
    const mouseOverTrigger = (e: MouseEvent) => {
      if (!document.querySelector('div.event-box')) {
        const rdvPos = elem.getBoundingClientRect();
        this.openCloseEventBox(event, elem, true, rdvPos);
      }
    };

    (elem as HTMLElement).onmouseleave = () => {
      const rdvPos = elem.getBoundingClientRect();
      this.openCloseEventBox(event, elem, false, rdvPos);
    }

    (elem as HTMLElement).onmouseenter = (e) => {
      mouseOverTrigger(e);
    };

    (elem as HTMLElement).onmousemove = (e) => {
      mouseOverTrigger(e);
    };
  }

  private openCloseEventBox(event: Event, elem: Element, doOpen = false, rdvPos: any): void {
    if (doOpen && !rdvPos) {
      rdvPos = elem.getBoundingClientRect();
    }
    const right = document.getElementsByClassName('right-part')[0];
    const id = String(event.id);

    const box = right?.querySelector(`div#${BOX_EVENT_ID_PREFIX}${id}.event-box`);

    if (this.previousElemStatusListOpened) return;

    // FERMETURE
    if (!doOpen) {
      if (box && right) {
        this.renderer.setStyle(elem.parentElement.parentElement.parentElement, 'z-index', '1');
        right.removeChild(box);
      }

      const ref = this.eventBoxRefs.get(id);
      if (ref) {
        ref.destroy();                 // ✅ IMPORTANT
        this.eventBoxRefs.delete(id);  // ✅ IMPORTANT
      }
      return;
    }

    // ✅ OUVERTURE (si déjà ouvert -> rien)
    if (box || this.eventBoxRefs.has(id)) return;

    const host = this.renderer.createElement('div');
    this.renderer.addClass(host, 'event-box');
    this.renderer.setAttribute(host, 'id', `${BOX_EVENT_ID_PREFIX}${id}`);
    this.renderer.setStyle(elem.parentElement.parentElement.parentElement, 'z-index', '2');

    const factory = this.resolver.resolveComponentFactory(EventBoxFragment);
    const eventBoxRef = this.viewContainerRef.createComponent(factory);
    eventBoxRef.instance.event = event;

    this.eventBoxRefs.set(id, eventBoxRef);

    // ref.location.nativeElement est le root DOM du component (plus sûr que instance.el)
    this.renderer.appendChild(host, eventBoxRef.location.nativeElement);
    this.renderer.appendChild(right, host);

    // positionnement comme avant
    this.renderer.setStyle(eventBoxRef.location.nativeElement, 'opacity', 0);
    this.renderer.setStyle(eventBoxRef.location.nativeElement, 'top', rdvPos.top + 'px');

    setTimeout(() => {
      this.renderer.setStyle(eventBoxRef.location.nativeElement, 'left', (rdvPos.left - eventBoxRef.location.nativeElement.offsetWidth) + 'px');
      this.renderer.setStyle(eventBoxRef.location.nativeElement, 'opacity', 100);
    }, 0);
  }


  private canHandleEventsInDom(nodes: NodeListOf<Element>): boolean {
    if (this.events.length <= 0 && nodes.length === this.events.length) {
      return true;
    }

    if (this.events.length <= 0 && nodes.length !== this.events.length) {
      return false;
    }

    if (this.events.length > 0 && nodes.length !== this.events.length) {
      return false;
    }

    const nodeEventId = this.getEventIdFromDOM(nodes[nodes.length - 1]);
    if (!nodeEventId) return false;
    const eventTmp = [...this.events];
    eventTmp.sort((a, b) => {
      return new Date(a.start).getTime() - new Date(b.start).getTime();
    });

    if (String(nodeEventId) === String(eventTmp[eventTmp.length - 1].id)) {
      return true;
    }

    return false;
  }

  /**
   * Récupérer l'ID de l'event à partir du node représentant cet event
   */
  private getEventIdFromDOM(node: any): string | null {
    const el: Element | null =
      (node instanceof Element) ? node :
      (node?.target instanceof Element) ? node.target :
      (node?.srcElement instanceof Element) ? node.srcElement :
      null;

    if (!el) return null;

    // 1) si l’élément (ou un parent) porte déjà data-event-id
    const carrier = el.closest?.('[data-event-id]') as Element | null;
    if (carrier) return carrier.getAttribute('data-event-id');

    // 2) sinon on remonte à cal-event et on cherche dedans
    const calEvent = el.closest?.('div.cal-event') as Element | null;
    const inside = calEvent?.querySelector?.('[data-event-id]') as Element | null;
    return inside?.getAttribute('data-event-id') ?? null;
  }

  /**
   * Ouvrir la liste des statuts d'un event
   */
  private async openCloseStatusList(event: CalendarEvent) {
    if (this.isEventReadOnly(event.meta)) {
      return
    }
    // On récupère l'élément du DOM représentant l'event
    const eventElem = await this.getEventElementByIdFromDOM(event.id as string);

    if (this.previousElemStatusListOpened && this.previousElemStatusListOpened !== eventElem) {
      // Si l'élément d'event précédement ouvert existe et qu'il est différent de l'élément actuellement cliqué
      // alors on change le z-index du parent de son parent
      // pour que celui-ci ne passe pas par dessus la liste des statuts de l'élément actuellement cliqué
      this.previousElemStatusListOpened.parentElement.parentElement.style.zIndex = '1';

      // On retire une class pour tourner la flèche
      //this.renderer.removeClass(this.previousElemStatusListOpened.querySelector('.dropOut .arrow'), 'open');
    }

    // Pour savoir si un élément est ouvert ou fermé, on regarde le z-index du parent du parent de celui-ci
    if (window.getComputedStyle(eventElem.parentElement.parentElement).zIndex === '1') {
      const hypermedEvent = this.hypermedEvents.find(e => e.id === event.id);
      this.openCloseEventBox(hypermedEvent, eventElem, false, null);

      // On passe le z-index de l'élément à 2 pour qu'il puisse passer par dessus les autres éléments
      eventElem.parentElement.parentElement.style.zIndex = '2';

      // On génère un élément DIV qui est une liste de statuts
      const statusListElem = this.generateStatusListDOMElem(event);

      // On ajoute élément DIV à l'élément cliqué
      eventElem.appendChild(statusListElem);

      // On ajoute une class pour tourner la flèche
      //this.renderer.addClass(eventElem.querySelector('.dropOut .arrow'), 'open');

      // On indique que l'élément précédemment cliqué devient celui actuellement cliqué
      this.previousElemStatusListOpened = eventElem;

      // Retirer la box d'informations
      const box = eventElem.querySelector(`div#${BOX_EVENT_ID_PREFIX}${event.id}.event-box`);
      this.renderer.setStyle(eventElem.parentElement.parentElement.parentElement, 'z-index', '1');
      if (box) {
        eventElem.removeChild(box);
      }
    } else {
      // On passe le z-index de l'élément à 1 pour qu'il ne passe pas par dessus la prochaine liste qui sera ouverte
      eventElem.parentElement.parentElement.style.zIndex = '1';

      // On récupère  l'émément de liste de statuts
      const statusListElem = this.generateStatusListDOMElem(event);

      // On retire l'élément de liste de statuts du DOM
      eventElem.removeChild(statusListElem);

      // On retire une class pour tourner la flèche
      //this.renderer.removeClass(eventElem.querySelector('.dropOut .arrow'), 'open');

      // L'élément précédement cliqué devient null
      this.previousElemStatusListOpened = null;
    }
  }

  /**
   * Cette méthode permet de retrouver l'élément du DOM représentant un event calendar
   */
  private async getEventElementByIdFromDOM(eventId: string): Promise<HTMLElement> {
    return new Promise<HTMLElement>(async (resolve) => {
      const elem = (document.querySelector(`[data-event-id="${eventId}"]`) as HTMLElement);

      if (!elem) {
        setTimeout(async () => {
          resolve(await this.getEventElementByIdFromDOM(eventId));
        }, 200);
      } else {
        resolve(elem.parentElement.parentElement.parentElement);
      }
    });
  }

  /**
   * Cette méthode génère et renvoit un élément DOM contenant la liste des statuts d'event
   */
  private generateStatusListDOMElem(event: CalendarEvent): HTMLDivElement {
    // Si l'lément contenant la liste des statuts n'existe pas, on le créé
    if (!this.listStatusElem) {
      const divElem = document.createElement('div');
      divElem.className = 'status-list-wrapper';

      for (const status of this.statusList) {
        const statusElem = document.createElement('span');
        statusElem.setAttribute('value', status.id);
        statusElem.textContent = status.label;
        divElem.appendChild(statusElem);
      }

      this.listStatusElem = divElem;
    }

    // On récupère la l'event ayant l'ID donné
    const hypermedEvent = this.getEventByIdFromLocalList(event.id as string);

    // Pour chaque élément de l'élément contenant la liste des statuts
    // on set le code couleur lié à l'event donné
    this.listStatusElem.childNodes.forEach((elem) => {
      const color = hypermedEvent.type && hypermedEvent.type.couleur ? hypermedEvent.type.couleur : '#a7d54e';
      (elem as Element).className = 'status-elem';
      elem.appendChild(document.createElement('style')).innerHTML = `.status-elem.selected { color: ${color} !important; }`;
      elem.appendChild(document.createElement('style')).innerHTML = `.status-elem:hover { color: ${color} !important; }`;

      if (hypermedEvent.status && hypermedEvent.status.id === (elem as Element).getAttribute('value')) {
        (elem as Element).className = 'status-elem selected';
      }

      (elem as HTMLElement).onclick = (e) => {
        e.stopPropagation();
        this.changeStatusForEvent(event, (elem as Element).getAttribute('value'));
      };
    });

    return this.listStatusElem;
  }

  private async changeStatusForEvent(event: CalendarEvent,newStatusId: string,opts: { fromContextMenu?: boolean } = {}) {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);
    const hypermedEvent = this.hypermedEvents.find((e) => e.id === event.id);

    try {
      if (!hypermedEvent) return;

      // Si même statut : ne surtout pas "toggle" le dropOut depuis le context-menu
      if (hypermedEvent.status?.id === newStatusId) {
        if (!opts.fromContextMenu) {
          this.openCloseStatusList(event); // legacy: toggle
        } else {
          // optionnel : si tu veux être sûr de fermer si déjà ouvert
          // this.closeStatusListIfOpen(event);
        }
        return;
      }

      await this.agendaSrv.updateEventStatus(event.id as string, newStatusId);

      const status = this.getStatusByIdFromLocalList(newStatusId);
      hypermedEvent.status = status;


      const elem = await this.getEventElementByIdFromDOM(event.id as string);
      // (elem.querySelector('.dropOut') as HTMLDivElement).setAttribute('title', status.label);
      // (elem.querySelector('.dropOut .label') as HTMLDivElement).innerText = status.label;
      const badge = elem.querySelector('[data-status-badge="1"]') as HTMLElement | null;

      if (badge) {
        const label = status?.label ?? '';
        badge.textContent = '';           // ou '' si tu veux juste l’icône
        badge.setAttribute('title', label);

        // update classe
        const labelNorme = this.normalizeStatusLabel(label ?? '');
        const key = this.STATUS_ICON_CLASS_BY_KEY[labelNorme] ?? 'st-default';
        badge.className = `status-badge ${key}`;
      }

      // 🔥 Ici est le vrai bug : tu toggles à la fin -> ça ouvre.
      if (!opts.fromContextMenu) {
        this.openCloseStatusList(event);
      } else {
        // optionnel : close-only si tu veux
        // this.closeStatusListIfOpen(event);
      }
    } catch (e) {
      this.modalSrv.openAlert(
        this.viewContainerRef,
        'Erreur',
        'Une erreur est survenue lors de la modification du statut de ce rendez-vous'
      );
    } finally {
      loading.destroy();
    }
  }

  private async getUnplannedEvents(): Promise<Array<CalendarEvent>> {
    const unplannedEvents = await this.agendaSrv.getUnplannedEvents(this.currentResource);

    for (const e of unplannedEvents) {
      if (e.patient) {
        e.patient.dateNaissance = e.patient.dateNaissance.split('-').reverse().join('-');
      }
    }

    this.hypermedEvents = [...this.hypermedEvents, ...unplannedEvents];

    const rtdArr: Array<CalendarEvent> = [];

    for (const event of unplannedEvents) {
      rtdArr.push({
        id: event.id,
        title: event.patient ? SafeHtmlUtils.escapeHtml(event.patient.nom) + ' ' + SafeHtmlUtils.escapeHtml(event.patient.prenom) + ' (' + SafeHtmlUtils.escapeHtml(event.patient.dateNaissance) + ')' : '',
        start: event.dateDebut,
        end: event.dateFin,
        draggable: event.infosAccessible && !this.isEventReadOnly(event),
        resizable: {
          afterEnd: event.infosAccessible && !this.isEventReadOnly(event),
          beforeStart: event.infosAccessible && !this.isEventReadOnly(event),
        },
        cssClass: 'custom-calendar',
        color: {
          primary: event.type && event.type.couleur !== '' ? event.type.couleur : 'var(--primary)',
          secondary: 'var(--white)'
        },
        meta: event
      });
    }
    return rtdArr;
  }

  private async getResources(): Promise<Array<EventResource>> {
    const resources = await this.agendaSrv.getResources();
    return resources;
  }

  private getEventByIdFromLocalList(eventId: string): Event {
    return this.hypermedEvents.find((e) => e.id === eventId);
  }

  private async updateEvent(event: Event, doForce = false): Promise<void> {
    if (!this._initLoading) {
      this._initLoading = this.modalSrv.openLoading(this.viewContainerRef);

      this._initLoading.onDestroy(() => {
        this._initLoading = undefined;
      });
    }

    try {
      const updatedEvent = await this.agendaSrv.updateEvent(event, doForce);
      if (updatedEvent) {
        let localArrEventIndex = this.hypermedEvents.findIndex((e) => e.id === event.id);
        this.hypermedEvents.splice(localArrEventIndex, 1, updatedEvent);

        localArrEventIndex = this.events.findIndex((e) => e.id === event.id);
        this.events.splice(localArrEventIndex, 1, {
          id: updatedEvent.id,
          title: '',
          start: new Date(updatedEvent.dateDebut),
          end: new Date(updatedEvent.dateFin),
          draggable: event.infosAccessible && !this.isEventReadOnly(event),
          resizable: {
            afterEnd: event.infosAccessible && !this.isEventReadOnly(event),
            beforeStart: event.infosAccessible && !this.isEventReadOnly(event),
          },
          cssClass: 'custom-calendar',
          color: {
            primary: updatedEvent.type && updatedEvent.type.couleur !== '' ? updatedEvent.type.couleur : 'var(--primary)',
            secondary: 'var(--white)'
          },
          meta: updatedEvent
        });
      }

      this.events = [...this.events];

      setTimeout(async () => {
        const elem = await this.getEventElementByIdFromDOM(event.id);
        //this.setEventDropOut(elem);
        this.setEventBoxForEvent(elem);
      }, 0);
    } catch (e) {
      if (e.status && e.status === 409 && (e.error.conflits[0].reason === 'SLOT_CONFLICT' || e.error.conflits[0].reason === 'PERIODE_CONFLICT')) {
        if (e.error && Array.isArray(e.error) && e.error.length > 0){
        const modal = this.modalSrv.openModal(this.viewContainerRef, EventConflictComponent);
        modal.instance.explication = 'L\'enregistrement de ce rendez-vous rentre en conflit avec un ou plusieurs rendez-vous et/ou périodes existants dont voici la liste';

          for (const data of e.error) {
            modal.instance.conflictsList.push(data.payload);
          }
          const sub = modal.instance.closeEmitter.subscribe(async (rtd) => {
            if (rtd) {
            }
            modal.destroy();
            sub.unsubscribe();
          });

        }else { // pas de liste de rdv suite conflit drag n drop
          await this.updateEvent(event, true);
        }



      } else {
        throw e;
      }
    } finally {
      if (this._initLoading) {
        this._initLoading.destroy();
      }
      await this.initData();
    }
  }

  private async getStatusList(): Promise<Array<EventStatus>> {
    return await this.agendaSrv.getStatus();
  }

  private getStatusByIdFromLocalList(newStatusId): EventStatus {
    return this.statusList.find((s) => s.id === newStatusId);
  }

  private async __doDeleteEvent(eventId: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      if (!this._initLoading) {
        this._initLoading = this.modalSrv.openLoading(this.viewContainerRef);

        this._initLoading.onDestroy(() => {
          this._initLoading = undefined;
        });
      }

      try {
        // Récupérer l'event
        const event = this.getEventByIdFromLocalList(eventId);


        // Vérifier si l'event contient des récurrences
        if (event.recurrence) {
          let msg = '';
          if (event.patient) {
            msg = `Le rendez-vous avec ${event.patient.nom} ${event.patient.prenom} le `;
          } else {
            msg = 'Le rendez-vous du ';
          }

          msg += `${moment(event.dateDebut).format('DD/MM/YYYY')} à ${moment(event.dateDebut).format('kk:mm')} est récurrent.`;

          const modal = this.modalSrv.openModalMultipleChoice(
            this.viewContainerRef,
            'Attention',
            msg,
            'Que voulez-vous faire ?',
            [
              { label: 'Ne pas supprimer', value: '' },
              { label: 'Supprimer seulement ce rendez-vous', value: 'only_event' },
              { label: 'Supprimer les récurrences à venir', value: 'coming_events' },
              { label: 'Supprimer toutes les récurrences', value: 'all_events' }
            ]
          );

          const sub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
            if (choice === 'only_event') {
              await this.agendaSrv.deleteEvent(eventId);
              this.__removeEventFromList(eventId);
              resolve();
            } else if (choice === 'coming_events') {
              await this.agendaSrv.deleteEvent(eventId, 'coming');
              this.__removeEventFromList(eventId);
              await this.initData();
              resolve();
            } else if (choice === 'all_events') {
              await this.agendaSrv.deleteEvent(eventId, 'previous_coming');
              this.__removeEventFromList(eventId);
              await this.initData();
              resolve();
            } else {
              resolve();
            }
          });
        } else {
          await this.agendaSrv.deleteEvent(eventId);
          this.__removeEventFromList(eventId);
          resolve();
        }
      } catch (e) {
        reject(e);
      } finally {
        if (this._initLoading) {
          this._initLoading.destroy();
        }
      }
    });
  }

  private __removeEventFromList(eventId: string) {
    let eventIndex = this.events.findIndex((e) => e.id === eventId);
    if (eventIndex > -1) {
      this.events.splice(eventIndex, 1);
      this.events = [...this.events];
    }

    eventIndex = this.hypermedEvents.findIndex((e) => e.id === eventId);
    if (eventIndex > -1) {
      this.hypermedEvents.splice(eventIndex, 1);
      this.hypermedEvents = [...this.hypermedEvents];
    }

    eventIndex = this.lastEventsClicked.findIndex((e) => e.id === eventId);
    if (eventIndex > -1) {
      this.lastEventsClicked.splice(eventIndex, 1);
      this.lastEventsClicked = [...this.lastEventsClicked];
    }
  }

  private setNavigationParams(): void {
    localStorage.setItem('agenda_nav_viewdate', this.viewDate.toDateString());

    if (this.currentResource) {
      localStorage.setItem('agenda_nav_current_resource', JSON.stringify(this.currentResource));
    }
  }

  private getNavigationParams(param: string): string | undefined {
    const item = localStorage.getItem(param);
    if (item) {
      localStorage.removeItem(param);
      return item;
    } else {
      return undefined;
    }
  }

  private async _getResourceSettings(resourceId: string, resourceType: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        this.agendaStartHour = '';
        setTimeout(async () => {
          const settings = await this.resourceSrv.getResourceSettings(resourceId, resourceType);

          const start = this.resourceSrv.getSettingFromArray(settings, 'hourStart');
          if (start && start.value) {
            this.agendaStartHour = start.value.split(':')[0];
            this.agendaStartMinute = start.value.split(':')[1];
          } else {
            this.agendaStartHour = '9';
            this.agendaStartMinute = '0';
          }

          const end = this.resourceSrv.getSettingFromArray(settings, 'hourEnd');
          if (end && end.value) {
            this.agendaEndHour = end.value.split(':')[0];
            this.agendaEndMinute = end.value.split(':')[1];
          } else {
            this.agendaEndHour = '19';
            this.agendaEndMinute = '0';
          }

          const height = this.resourceSrv.getSettingFromArray(settings, 'hourHeight');
          this.hourHeight = height && height.value ? Number(height.value) / 4 : 30;

          const refreshRate = this.resourceSrv.getSettingFromArray(settings, 'refreshRate');
          if (this.refreshInstance) {
            clearInterval(this.refreshInstance);
          }
          this.refreshRate = refreshRate && refreshRate.value ? Number(refreshRate.value) * 60 * 1000 : 0;

          const showHollidays = this.resourceSrv.getSettingFromArray(settings, 'show_hollidays');
          this.showHollidays = showHollidays && showHollidays.value === 'true' ? true : false;
          resolve();
        }, 0);

      } catch (e) {
        throw e;
      }
    });
  }

  private handlePeriodesDisplay(periodes: Array<AgendaPeriode>) {
    for (const p of periodes) {
      let dayStart = moment();
      let dayEnd = moment();
      if (p.estRecurrent) {
        dayStart = moment(this.viewDate).startOf('week').add(p.jourRecurrence, 'day')
          .hour(Number(p.heureDebut.split(':')[0]))
          .minute(Number(p.heureDebut.split(':')[1]));

        dayEnd = moment(this.viewDate).startOf('week').add(p.jourRecurrence, 'day')
          .hour(Number(p.heureFin.split(':')[0]))
          .minute(Number(p.heureFin.split(':')[1]));
      } else if (p.periodeDateDebut && p.periodeDateFin) {
        dayStart = moment(p.periodeDateDebut).hour(Number(p.heureDebut.split(':')[0])).minute(Number(p.heureDebut.split(':')[1])).second(0).millisecond(0);
        dayEnd = moment(p.periodeDateFin).hour(Number(p.heureFin.split(':')[0])).minute(Number(p.heureFin.split(':')[1])).second(0).millisecond(0);

        if (p.heureFin === '00:00') {
          dayEnd.add(1, 'day');
        }
      }

      if (dayStart.hour() === 0 && dayStart.minute() === 0 && dayStart.isSame(dayEnd)) {
        dayStart.startOf('day');
        dayEnd.endOf('day');
      }

      let displayedHourSegments: Array<Element> = [];
      while (dayStart.isBefore(dayEnd)) {
        const dayDisplayed = window.document.querySelector(`[data-segment-hour="${dayStart.toDate().toString()}"]`);

        if (dayDisplayed) {

          if (displayedHourSegments.length > 0 && moment(dayDisplayed.getAttribute('data-segment-hour')).isAfter(moment(displayedHourSegments[displayedHourSegments.length - 1].getAttribute('data-segment-hour')), 'day')) {
            this.setPeriodeLabel([...displayedHourSegments], periodes, p.id, p.titre);
            displayedHourSegments = [];
          }

          displayedHourSegments.push(dayDisplayed);

          const bgRgb = this._hexToRgb(p.couleurFond);

          const currentBgColor = window.getComputedStyle(dayDisplayed).backgroundColor;

          if (currentBgColor !== 'rgba(0, 0, 0, 0)') {
            const current = currentBgColor.split('rgba(')[1].split(')')[0].split(', ');
            const blended = this._blendColors(
              [Number(current[0]), Number(current[1]), Number(current[2])],
              [bgRgb.r, bgRgb.g, bgRgb.b]);
            bgRgb.r = blended.r;
            bgRgb.g = blended.g;
            bgRgb.b = blended.b;
          } else {
            this.renderer.setStyle(dayDisplayed, 'color', `${p.couleurTexte}`);
          }

          this.renderer.setStyle(dayDisplayed, 'background-color', `rgba(${bgRgb.r}, ${bgRgb.g}, ${bgRgb.b}, 0.3)`);
        }

        dayStart.add(15, 'minute');
      }

      if (displayedHourSegments.length > 0 && moment(displayedHourSegments[0].getAttribute('data-segment-hour')).isSameOrAfter(moment(displayedHourSegments[displayedHourSegments.length - 1].getAttribute('data-segment-hour')), 'day')) {
        this.setPeriodeLabel([...displayedHourSegments], periodes, p.id, p.titre);
      }
    }
  }

  private setPeriodeLabel(elems: Array<Element>, periodes: Array<AgendaPeriode>, periodeId: string, periodeLabel: string) {
    let segmentWithLabel = elems[0];
    if (segmentWithLabel) {
      if (segmentWithLabel.id) {
        const extractIds = (initialId: string) => {
          const ids: Array<string> = [periodeId];
          for (const p of periodes) {
            if (initialId.includes(p.id)) {
              ids.push(p.id);
            }
          }

          return ids;
        };

        const ids = extractIds(segmentWithLabel.id);

        let segmentId = 'periode_label_';
        const contentArr: Array<string> = [];
        for (const id of ids) {
          segmentId += `__${id}`;
          contentArr.push(periodes.find(per => per.id === id).titre);
        }

        const content = contentArr.length === 0 ? periodeLabel : contentArr.join('\\00000a');

        this.renderer.setAttribute(segmentWithLabel, 'id', `${segmentId}`);
        segmentWithLabel.querySelector('style').innerHTML = `#${segmentId}::before { content: '${content}'; position: absolute; width: 100%; text-align: center; font-size: 1.2rem; text-transform: capitalize; font-weight: 500; top: 0.5rem }`;
      } else {
        this.renderer.setAttribute(segmentWithLabel, 'id', `periode_label_${periodeId}`);
        this.renderer.setStyle(segmentWithLabel, 'position', 'relative');
        const content = periodes.find(per => per.id === periodeId).titre;
        segmentWithLabel.appendChild(document.createElement('style')).innerHTML = `#periode_label_${periodeId}::before { content: '${content}'; position: absolute; width: 100%; text-align: center; font-size: 1.2rem; text-transform: capitalize; font-weight: 500; bottom: 0 }`
      }
    }
  }

  private _hexToRgb(hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    };
  }

  private _blendColors(rgbColor1: Array<number>, rgbColor2: Array<number>): { r: number, g: number, b: number } {
    return {
      r: 0.5 * rgbColor1[0] + (1 - 0.5) * rgbColor2[0],
      g: 0.5 * rgbColor1[1] + (1 - 0.5) * rgbColor2[1],
      b: 0.5 * rgbColor1[2] + (1 - 0.5) * rgbColor2[2]
    }
  }

  private _isAllowInPeriode(start: Date, end: Date): boolean {
    let rtd = true;
    for (const p of this.periodes) {
      let dayStart = moment();
      let dayEnd = moment();
      if (p.estRecurrent) {
        dayStart = moment().startOf('week').add(p.jourRecurrence, 'day')
          .hour(Number(p.heureDebut.split(':')[0]))
          .minute(Number(p.heureDebut.split(':')[1]));

        dayEnd = moment().startOf('week').add(p.jourRecurrence, 'day')
          .hour(Number(p.heureFin.split(':')[0]))
          .minute(Number(p.heureFin.split(':')[1]));
      } else if (p.periodeDateDebut && p.periodeDateFin) {
        dayStart = moment(p.periodeDateDebut).hour(Number(p.heureDebut.split(':')[0])).minute(Number(p.heureDebut.split(':')[1])).second(0).millisecond(0);
        dayEnd = moment(p.periodeDateFin).hour(Number(p.heureFin.split(':')[0])).minute(Number(p.heureFin.split(':')[1])).second(0).millisecond(0);
      }

      if (dayStart.hour() === 0 && dayStart.minute() === 0 && dayStart.isSame(dayEnd)) {
        dayStart.startOf('day');
        dayEnd.endOf('day');
      }

      if ((moment(start).isBetween(dayStart, dayEnd) || moment(end).isBetween(dayStart, dayEnd)) && !p.autoriserPriseRendezVous) {
        rtd = false;
        break;
      }

      if ((dayStart.isBetween(start, end) || dayEnd.isBetween(start, end)) && !p.autoriserPriseRendezVous) {
        rtd = false;
        break;
      }
    }

    return rtd;
  }

  private async _eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent, doForce = false) {
    if (!this._initLoading) {
      this._initLoading = this.modalSrv.openLoading(this.viewContainerRef);

      this._initLoading.onDestroy(() => {
        this._initLoading = undefined;
      });
    }

    const rollBackEvent = { ...event };
    const hypermedEvent = this.hypermedEvents.find((e) => e.id === event.id);
    const unplannedEventIndex = this.unplannedEvents.indexOf(event);

    try {
      if (newEnd) {
        if (event.start.toString() === newStart.toString()
          && event.end.toString() === newEnd.toString()) {
          /**
           * La sensibilité du drag n drop de la librairie angular-calendar fait que parfois un click peut-être interprété comme un drag n drop
           * On peut s'en rendre compte si les heures de l'évènement n'ont pas changé
           * Dans ce cas, on appel la fonction correspondant à un simple click
           */
          this.eventClicked({ event: event });
        } else {
          hypermedEvent.dateDebut = newStart;
          hypermedEvent.dateFin = newEnd;
          hypermedEvent.planifie = true;

          await this.updateEvent(hypermedEvent, doForce);
        }
      } else { //rdv non planif drop in agenda
        const tmpEvent: CalendarEvent = event;
        tmpEvent.start = newStart;
        tmpEvent.end = moment(newStart)
          .add(hypermedEvent.type ? Number(hypermedEvent.type.duree.split(':')[0]) : 0, 'hour')
          .add(hypermedEvent.type ? Number(hypermedEvent.type.duree.split(':')[1]) : 15, 'minutes')
          .toDate();
        tmpEvent.meta.dateStart = newStart;
        tmpEvent.meta.dateEnd = tmpEvent.end;
        hypermedEvent.dateDebut = tmpEvent.start;
        hypermedEvent.dateFin = tmpEvent.end;
        hypermedEvent.planifie = true;

        if (unplannedEventIndex > -1) {
          // On retire l'event de la liste des events non planifiés
          this.unplannedEvents.splice(unplannedEventIndex, 1);
          //on affecte la ressource courante de l'agenda sinon la création bloque
          hypermedEvent.ressourses = [this.currentResource];
          // on force l'update si on drop un rdv non planif pour eviter le blocage surbooking sur update.
          doForce = true
          // On ajoute l'event à la liste des agenda events
          this.events = [...this.events, tmpEvent];

        }

        // On update l'event
        await this.updateEvent(hypermedEvent, doForce);
      }
    } catch (e) {
      // En cas d'erreur on rollback les tableaux d'events et d'events non planifiés
      if (unplannedEventIndex > -1) {
        this.unplannedEvents.splice(unplannedEventIndex, 1, rollBackEvent);
      }

      const eventIndex = this.events.indexOf(rollBackEvent);
      if (eventIndex > -1) {
        this.events.splice(eventIndex, 1);
        this.events = [...this.events];
      }
    } finally {
      await this.handleEventsInDom();
      if (this._initLoading) {
        this._initLoading.destroy();
      }
    }
  }

  private _initTimeMarker() {
    const timeMarker = document.querySelector('mwl-calendar-week-view-current-time-marker div');
    const calContainer = document.querySelector('div.cal-time-events');

    if (!timeMarker || !calContainer) {
      setTimeout(() => {
        this._initTimeMarker();
      }, 50);
    } else {
      const newTimeMarker = timeMarker.cloneNode();
      this.renderer.appendChild(calContainer, newTimeMarker);

      if (this.intervalTimeMarker) {
        clearInterval(this.intervalTimeMarker);
      }

      this.intervalTimeMarker = setInterval(() => {
        const div = document.querySelector('mwl-calendar-week-view-current-time-marker div');
        if (div) {
          const nodeStyle = window.getComputedStyle(div);
          (newTimeMarker as HTMLElement).style.top = nodeStyle.top;
        }
      }, 500)
    }
  }
  public isLastEventReadOnly(): boolean {
    if (this.lastEventsClicked && this.lastEventsClicked.length > 0) {
      const last = this.lastEventsClicked[this.lastEventsClicked.length - 1]
      return this.isEventReadOnly(last.meta);
    }
    return false;
  }

  public isEventReadOnly(event) {
    // Vérification générale : si currentProfil est indéfini, on retourne true (normalement impossible)
    if (!this.currentProfil) {
      return true;
    }
    // aprés ceci on a toujours acces si on a acces à l'agenda de la ressource pas besoin de faire compliqué et pas de verification systematique pour tout
    // le createdBy n'est pas la pour gere un droit d'acces mais pour une trace de qui a fait quoi uniquement

    return false;
  }

  public getEventColor(event: Event) {
    if (event.type) {
      return event.type.couleur
    } else if (!event.infosAccessible) {
      return '#505050'
    } else {
      return '#a7d54e';
    }
  }

  public async doPrintViewAgenda(): Promise<void> {

    if (this.isPrinting) return;
    this.isPrinting = true;
    const loadingRef = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      const viewEvents = this.events ?? [];
      if (!viewEvents.length) return;

      const rows = viewEvents
        // tri chronologique (optionnel)
        .slice()
        .sort((a: any, b: any) => (a.start?.getTime?.() ?? 0) - (b.start?.getTime?.() ?? 0))
        .map((ev: any) => {
          const m = ev.meta || {}; // HypermedEvent complet

          const heureDebut = ev.start ? moment(ev.start).format('HH:mm') : (m.dateDebut ? moment(m.dateDebut).format('HH:mm') : '');
          const heureFin   = ev.end   ? moment(ev.end).format('HH:mm')   : (m.dateFin   ? moment(m.dateFin).format('HH:mm')   : '');

          const patient = m.patient
            ? `${SafeHtmlUtils.escapeHtml(m.patient.nom ?? '')} ${SafeHtmlUtils.escapeHtml(m.patient.prenom ?? '')} ${SafeHtmlUtils.escapeHtml(m.patient.dateNaissance ?? '')}`.trim()
            : '';

          const type = m.type?.label ?? m.type ?? '';
          const description = SafeHtmlUtils.escapeHtml(this.normalizeInlineText(m.description ?? '', ' - '));

          // Ressources : selon votre modèle (adapter si besoin)
          const ressourcesStr = Array.isArray(m.resources)
            ? m.resources.map((r: any) => r?.nom ?? r?.label ?? String(r)).join(', ')
            : (m.resources ?? m.ressources ?? '');

          const ressources = SafeHtmlUtils.escapeHtml(this.normalizeInlineText(ressourcesStr, ', '));

          return {
            date: ev.start ? this.frDate(ev.start) : this.frDate(m.dateDebut),
            heureDebut,
            heureFin,
            patient,
            type,
            description,
            ressources,
          };
        });

      const currentDate = this.calendarUnity !== this.calendarViewEnum.Day
        ? this.GetTitleCalendar()
        : this.frDate(this.viewDate);

      const title = this.calendarUnity !== this.calendarViewEnum.Day
        ? `Rendez-vous ${currentDate}`
        : `Rendez-vous du ${currentDate}`;

      await this.printViaIframeAsync({
        title,
        landscape: true,
        columns: [
          { label: 'Date',        key: 'date',        align: 'left', width:'40px' },
          { label: 'de',          key: 'heureDebut',  align: 'center', width:'30px' },
          { label: 'à',           key: 'heureFin',    align: 'center', width:'30px' },
          { label: 'Patient',     key: 'patient',     align: 'left', width:'28%' },
          { label: 'Type',        key: 'type',        align: 'left', width:'12%' },
          { label: 'Description', key: 'description', align: 'left', width:'35%' },
        ],
        rows,
        summaryHtml: '',

      });

    } catch (e) {
      console.error('Impression agenda échouée', e);
    } finally {
      loadingRef?.destroy();
      this.isPrinting = false;
    }
  }

  private frDate(d: any): string {
    if (!d) return '';
    const date = (d instanceof Date) ? d : new Date(d);
    if (isNaN(date.getTime())) return String(d);
    return date.toLocaleDateString('fr-FR');
  }

  private async printViaIframeAsync(opts: {
    title: string;
    columns: { label: string; key: string; align?: 'left'|'right'|'center'; width: string }[];
    rows: any[];
    landscape?: boolean;
    summaryHtml?: string;
  }): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const { title, columns, rows, landscape = true, summaryHtml } = opts;

      const ifr = document.createElement('iframe');
      Object.assign(ifr.style, {
        position: 'fixed',
        right: '0',
        bottom: '0',
        width: '0',
        height: '0',
        border: '0'
      });
      document.body.appendChild(ifr);

      const nowStr = new Date().toLocaleString('fr-FR').replace(/'/g, "\\'");

      const css = `
        @page {
          size: ${landscape ? 'A4 landscape' : 'A4 portrait'};
          margin: 12mm;
          @bottom-left  { content: '${nowStr}'; }
          @bottom-center { content: 'HyperMed Online ©™'; }
          @bottom-right { content: counter(page) ' / ' counter(pages); }
        }
        * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        body { font-family: Arial, sans-serif; font-size: 12px; }
        h3 { margin: 0 0 8px; }
        table { width: 100%; border-collapse: collapse; table-layout: fixed;}
        thead { display: table-header-group;background: #f5f5f5; }
        th, td {
          box-sizing: border-box;
          padding: 6px 8px;
          border-bottom: 1px solid #e0e0e0;
          border-top: 1px solid #e0e0e0;
          vertical-align: top;
          overflow-wrap: anywhere;
          word-break: break-word;
        }
          th, td {
            border-right: 1px dashed #999;
          }

          th:last-child,
          td:last-child {
            border-right: none;
          }
        th.left, td.left { text-align: left; }
        th.right, td.right { text-align: right; }
        th.center, td.center { text-align: center; }
        tbody tr:nth-child(odd) { background: #fcfcfc; }
        tr { break-inside: avoid; page-break-inside: avoid; }

        /* Synthèse */
        .summary-table { margin: 8px 0 12px 0; border: 1px solid #ccc; }
        .summary-table thead { background: #f5f5f5; }
        .summary-table th, .summary-table td { border-bottom: 1px solid #ddd; font-weight: 600; }
        .title {
          text-align: center;
          font-weight: bold;
          font-size: 16px;       /* un peu plus gros */
          color: #ff0000;        /* rouge */
          text-decoration: underline;
          margin: 0 0 10px 0;    /* espace sous le titre */
        }
      `;

      const colgroup = `
        <colgroup>
          ${columns.map(c => `<col style="width:${c.width};">`).join('')}
        </colgroup>
      `;

      const thead = `
        <thead><tr>
          ${columns.map(c => {
            const cls = c.align ? ` class="${c.align}"` : '';
            return `<th${cls}>${c.label}</th>`;
          }).join('')}
        </tr></thead>
      `;



      const tbody = `
        <tbody>
          ${rows.map(r => `
            <tr>
              ${columns.map(c => {
                const v = r[c.key] ?? '';
                const cls = c.align ? ` class="${c.align}"` : '';
                return `<td${cls}>${v}</td>`;
              }).join('')}
            </tr>`).join('')}
        </tbody>
      `;

      const summaryTable = summaryHtml ?? `
        <table class="summary-table">
          <thead><tr><th>Nombre de lignes</th></tr></thead>
          <tbody><tr><td class="center">${rows.length}</td></tr></tbody>
        </table>
      `;

      // Paged.js (si vous l’avez déjà dans assets comme pour factures)
      const pagedSrc = `${location.origin}/assets/pagedjs/paged.polyfill.js`;

      const html = `<!doctype html>
  <html><head>
    <meta charset="utf-8">
    <title>${title}</title>
    <style>${css}</style>
  </head>
  <body>
    <h3  class="title">${title} (${rows.length} rdv)</h3>
    ${summaryTable}
    <table>${colgroup}${thead}${tbody}</table>

    <script>
      let printed = false;
      const fallback = setTimeout(() => {
        if (!printed) {
          printed = true;
          try { parent.postMessage({type:'PRINT_START'}, '*'); } catch(e){}
          window.focus(); window.print();
          try { parent.postMessage({type:'CLEANUP_IFR'}, '*'); } catch(e){}
        }
      }, 1500);

      document.addEventListener('pagedjs:rendered', () => {
        if (!printed) {
          printed = true;
          clearTimeout(fallback);
          try { parent.postMessage({type:'PRINT_START'}, '*'); } catch(e){}
          setTimeout(() => {
            window.focus(); window.print();
            try { parent.postMessage({type:'CLEANUP_IFR'}, '*'); } catch(e){}
          }, 50);
        }
      });
    </script>
    <script src="${pagedSrc}"></script>
  </body></html>`;

      const doc = ifr.contentDocument || ifr.contentWindow?.document;
      if (!doc) {
        document.body.removeChild(ifr);
        reject(new Error('Impossible de créer le document d’impression'));
        return;
      }

      doc.open(); doc.write(html); doc.close();

      const onMsg = (e: MessageEvent) => {
        if (e?.data?.type === 'PRINT_START') resolve();
        if (e?.data?.type === 'CLEANUP_IFR') {
          window.removeEventListener('message', onMsg);
          setTimeout(() => {
            try { document.body.removeChild(ifr); } catch {}
          }, 100);
        }
      };
      window.addEventListener('message', onMsg);
    });
  }

  private normalizeInlineText(value: any, separator = ' - '): string {
    if (value == null) return '';

    return value
      .toString()
      // normalise tous les retours chariot
      .replace(/\r\n|\r|\n+/g, separator)
      // évite " -  - " ou " - - "
      .replace(/\s*-\s*-\s*/g, separator)
      // espaces multiples
      .replace(/\s{2,}/g, ' ')
      .trim();
  }



  public isSelectedEventReadOnly(): boolean {
    return !this.selectedEvent || this.isEventReadOnly(this.selectedEvent.meta);
  }

  public openStatusSubmenu() {
    if (this.isSelectedEventReadOnly()) return;
    this.showStatusSubmenu = true;
  }

  public closeStatusSubmenu() {
    this.showStatusSubmenu = false;
    if (this.closeStatusSubmenuTimer) {
      clearTimeout(this.closeStatusSubmenuTimer);
      this.closeStatusSubmenuTimer = null;
    }
  }

  public toggleStatusSubmenu(e: MouseEvent) {
    e.stopPropagation();
    if (this.isSelectedEventReadOnly()) return;
    this.showStatusSubmenu = !this.showStatusSubmenu;
  }

  public scheduleCloseStatusSubmenu() {
    if (this.closeStatusSubmenuTimer) clearTimeout(this.closeStatusSubmenuTimer);
    this.closeStatusSubmenuTimer = setTimeout(() => {
      this.showStatusSubmenu = false;
    }, 180);
  }

  public cancelCloseStatusSubmenu() {
    if (this.closeStatusSubmenuTimer) {
      clearTimeout(this.closeStatusSubmenuTimer);
      this.closeStatusSubmenuTimer = null;
    }
  }

  public async onStatusPicked(statusId: string) {
    if (!this.selectedEvent) return;

    // // garder le comportement cohérent avec vos actions existantes
    // this.setSelectionFromContext();

    await this.changeStatusForEvent(this.selectedEvent, statusId, { fromContextMenu: true });

    this.showStatusSubmenu = false;
    this.closeContextMenu();
  }

  private getTargetEvent(explicit?: CalendarEvent | null): CalendarEvent | null {
    return explicit ?? this.selectedEvent ?? (this.lastEventsClicked.length === 1 ? this.lastEventsClicked[0] : null);
  }

  private getTargetEvents(explicit?: CalendarEvent | null): CalendarEvent[] {
    // Si on clique depuis le menu, on veut 1 seul event (selectedEvent) sauf si tu veux un mode multi via sélection legacy.
    if (explicit) return [explicit];
    if (this.selectedEvent) return [this.selectedEvent];
    return [...this.lastEventsClicked];
  }

  private normalizeStatusLabel(label: string): string {
    return (label || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // accents
      .replace(/[^a-z0-9]+/g, ' ')                      // ponctuation -> espace
      .trim();
  }

  public statusIconClass(label?: string | null): string {
    if (!label) return 'st-default';
    const key = this.normalizeStatusLabel(label ?? '');
    return this.STATUS_ICON_CLASS_BY_KEY[key] ?? 'st-default';
  }

  async openPatientFolder(patientId: string) {
    if (this.isAlreadyClick) {
      return;
    }
    this.isAlreadyClick = true;
    // utilisation de ce endpoint pour verif droit acces TODO à faire autrement quand endPoint haveAcces ok
    const note = await this.patientSrv.findOnePatientNote(patientId);
    if(note !== undefined){
        this.__redirectToDossierPatient(patientId);
    }else{
      this.snack.openSnackBarError('Vous n\'avez pas les droits pour accéder à ce patient.');
    }
    this.isAlreadyClick = false;
  }

  private __redirectToDossierPatient(patientId: string) {
    window.open(`/user/patient/${patientId}`, '_blank');
  }

}
